import { Directive, EventEmitter, Input, Output } from '@angular/core';
@Directive()
export class NotesOptionsBase {
    @Output() onOpenReferenceDialog = new EventEmitter<void>();
    @Output() onAddNumberToggleEmit = new EventEmitter<boolean>();
    @Input() addNumbering: boolean;
    openReferenceDialog(): void {
        this.onOpenReferenceDialog.emit();
    }

    onAddNumberToggleChange(checked: boolean): void {
        this.onAddNumberToggleEmit.emit(checked);
    }
}
